module.exports = __webpack_public_path__ + "media/images/icon__link@3x-a5a67c5ad456932a2192625e2fd99ec3.png";